<template lang="pug">
	.creative--publish-schedule.flex-col.space
		.flex-row.space.align-center
			.flex-row.space.align-center
				.font-big.upper.grey {{$tCaption('Schedule')}}
				DxButton(v-if="!readonly", :hint="$tCaption('Add schedule')", @click="addSchedule", icon="plus", :disabled="!!isAddingSchedule")
			Loader(v-if="isLoading", text="")
		.flex-col.space(v-if="schedules.length")
			DxTabPanel.tab-panel-small(:dataSource="tabs")
				template(v-slot:title="{ data }")
					.flex-row.space.align-center
						fas(v-if="data.item.__saving", icon="spinner" :spin="true")
						span {{data.name}}
						.adt-button.rounded.clickable.hoverable.flex-row.align-center.center(@click="removeSchedule(data.item, data.itemIdx)", v-if="!readonly")
							fas(icon="times")
				template(v-slot:item="{ data }")
					.padding
						CreativePublishScheduleItem(:schedule="data.item", :creative="creative", @remove="schedules.splice(tabs.itemIdx, 1)", @create-template-field="tf => $emit('create-template-field', tf)", :readonly="readonly")
</template>

<script>
	import Loader from 'app-core/Loader.vue';
	import DxButton from 'devextreme-vue/button';
	import CreativePublishScheduleItem from './CreativePublishScheduleItem.vue';
	import DxTabPanel from 'devextreme-vue/tab-panel';

	export default {
		translationCategory: 'creative.PublishSchedule',
		name: 'creative--publish-schedule',
		components: {
			Loader, DxButton, CreativePublishScheduleItem, DxTabPanel
		},
		props: ['creative', 'readonly'],
		data() {
			return {
				schedules: [],
				isLoading: 0,
				isAddingSchedule: 0,
				activeItemIdx: 0
			};
		},
		computed: {
			activeItem() {
				return this.schedules[this.activeItemIdx];
			},
			tabs() {
				return this.schedules.map((f, i) => ({
					id: f.Oid,
					name: f.Name,
					item: f,
					itemIdx: i
				}))
			}
		},
		watch: {
			
		},
		mounted() {
			if (__DEBUG__)
				window.creativePublishSchedule = this;
			this.loadSchedules();
		},
		methods: {
			async loadSchedules() {
				this.isLoading++;
				this.schedules = (await this.$Data.getExternalApi('PublicationSchedule/List', `creativeId=${this.creative?.Oid}&sorting=[{ selector: 'StartDate', desc: false }, { selector: 'Name', desc: false }]`).finally(() => this.isLoading--))?.Results || [];
				this.activeItemIdx = 0;
			},
			async addSchedule() {
				this.isLoading++;
				this.isAddingSchedule++;
				const schedule = (await this.$Data.postExternalApi('PublicationSchedule/CreateUpdate', { 
					Oid: null,
					Creative: {
						Oid: this.creative.Oid
					},
					Name: this.$tCaption('New schedule'),
					StartDate: this.$Data.dateToString(),
					JsonConfig: {
						Interval: 60 * 4,
						ConditionTimeout: 60 * 24,
						BuildTimeout: 20
					}
				}).finally(() => {
					this.isLoading--;
					this.isAddingSchedule--;
				}))?.Data;

				if (schedule?.Oid) {
					this.schedules.push(schedule);
				}
			},
			removeSchedule(schedule, idx) {
				this.$confirm(void 0, this.$tCaption('Do you want to remove schedule?')).then(() => {
					if (__DEBUG__)
						console.debug('Remove schedule', { schedule });
					this.$set(schedule, '__saving', true);
					this.$Data.postExternalApi('PublicationSchedule/Delete', [schedule?.Oid]).finally(() => {
						this.$set(schedule, '__saving', false);
						this.schedules.splice(idx, 1);
						this.$notifySuccess('Schedule removed');
					});
				});
			}
		}
	};
</script>
<style lang='scss'>
	.creative--publish-schedule {
	}
</style>
